import { render, staticRenderFns } from "./ManageFabricationTypesModal.vue?vue&type=template&id=686aeee4&scoped=true"
import script from "./ManageFabricationTypesModal.vue?vue&type=script&lang=js"
export * from "./ManageFabricationTypesModal.vue?vue&type=script&lang=js"
import style0 from "./ManageFabricationTypesModal.vue?vue&type=style&index=0&id=686aeee4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "686aeee4",
  null
  
)

export default component.exports